jQuery.getJSON('/cart.js', function(cart) {
    $('.cart-sec a').html('<i class="fa fa-shopping-cart"></i> (' + cart.item_count + ') <span class="product_price_header">  | $' + cart.total_price / 100+'</span>');
});

// FOOD PREFERNCE COLLECTION FILTER
var totalProducts = 0;
// jQuery.getJSON('/admin/products/count.json', function(count) {
//     totalProducts = count.count;
// });

$(document).ready(function() {
    var client = ShopifyBuy.buildClient({
        accessToken: 'e1e6fd39cd8071caefd71f575b834542',
        domain: 'nacb.myshopify.com',
        appId: '6'
    });


    var alProductsData = []; // GLOBAL VARIABLES

    function productFetchAll(paginationLimit, callback) {
        client.fetchQueryProducts({
            page: paginationLimit,
            limit: 250
        }).then((products) => {
            products.forEach(function(item, index, array) {
                var title = products[index].title;
                var handle = products[index]['attrs']['handle'];
                var tags = products[index]['attrs']['tags'];
                var variants = products[index]['attrs']['variants'];
                var price = 0;
                var img = products[index]['images'];
                var img_src;
                img.forEach(function(item, index, array) {
                    img_src = img[index]['src'];
                });
                variants.forEach(function(item, index, array) {
                    if (index < 1) {
                        price = variants[index]['price'];
                    }
                    return false;
                });


                var items = {};
                items['title'] = title;
                items['handle'] = handle;
                items['tags'] = tags;
                items['price'] = price;
                items['img'] = img_src;
                alProductsData.push(items);
            });

            callback(alProductsData);
        });


    }

    // changing on load all fetch items

    setTimeout(function() {

        var pages = Math.ceil(parseInt(totalProducts) / 50);
        var i = 1;
        while (i <= pages) {
            productFetchAll(i, function(data) {});
            i++;
        }


    }, 1000);



    function foodPrefFilter() {
        var arr = [];
        $('.product-sec1').empty();
        $('.prefActive').each(function(e) {

            var ftag = $(this).val().toLowerCase();
            var newArr = alProductsData.filter(function(item) {
                arr = item.tags;
                return arr.indexOf(ftag) != -1;

            });

            if (newArr != '') {
                var title = newArr[0]['title'];
                var handle = newArr[0]['handle'];
                var price = newArr[0]['price'];
                var image = newArr[0]['img'];
                $('#scriptHtml .men-thumb-item img').attr('src', image);
                $('#scriptHtml .item-info-product h4 a').text(title);
                $('#scriptHtml .item-info-product h4 a').attr('href', '/products/' + handle);
                $('#scriptHtml span.item_price').text('$ ' + price);
                $('#scriptHtml .snipcart-details.single-item a').attr('href', '/products/' + handle);
                $('.product-sec1 .clearfix').remove();
                $('.product-sec1').append($('#scriptHtml').html());
            } else {
                $('.product-sec1').append('Products Not Found!');
            }

        });

    }

    $('.foodPrefFilter').change(function() {
        if ($(this).is(":checked")) {
            $(this).addClass('prefActive');
        } else {
            $(this).removeClass('prefActive');
        }

        foodPrefFilter();
    });
  
  

  $('.faqfield-question').click(function(e){
  	e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('div').slideToggle();
  
  });

$( ".search_Bar" ).click(function() {
  $( '.search' ).submit();
});

});